import React from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../contexts/store'
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'

import UxIcon from '../../Elements/UxIcon'
import Activity from './Activity'
import PodStatistics from './PodStatistics'

const ActivityStats = () => {
  const { t } = useTranslation()
  const { podStore, uiStore, sessionStore } = useStore()
  const deviceWidth = uiStore.deviceWidth
  const podId = podStore.pod?.podId
  if (!podId) return null

  const [activityMode, setActivityMode] = uiStore.useUiState<'stream'|'stats'>(`${podId}-activityMode`, 'stream')


 const Header = () => (
    <Box sx={{
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
      justifyContent: "end",
      padding: "5px 10px 15px 15px"
    }}>
      {deviceWidth !== "tiny" &&
        <UxIcon id="podMaterial" sx={{color: "primary.main", margin: "0 10px"}} fontSize="small" />
      }
      <ToggleButtonGroup
        color="primary"
        value={activityMode}
        exclusive
        onChange={(_, mode: 'stream'|'stats') => {setActivityMode(mode === 'stats' ? 'stats' : "stream")}}
        aria-label={String(t("Change between viewing the activity stream and a statistics overview"))}
        size="small"
        sx={{
          alignItems:"center",
          display: "flex",
          flexGrow: 1,
          flexWrap: "wrap",
          gap: "5px",
          padding: "10px 0"
        }}
      >
        <ToggleButton sx={{border: "none", fontSize: "18px",textTransform: "unset"}} value={"stream"}>{t('Activity Stream')}</ToggleButton>
        <ToggleButton sx={{border: "none", fontSize: "18px", textTransform: "unset"}} value={"stats"}>{t('Statistics')}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )

  return <>
    <Header />
    {activityMode === 'stream' && <Activity />}
    {activityMode === 'stats' && <PodStatistics />}
  </>
}

export default observer(ActivityStats)